import styled, { css } from 'styled-components'

export const SheetModalHandleLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: 16px;
  `}
  padding: 5px;
`

type LinkProps = {
  $isLinkEnabled?: boolean
}

export const Link = styled.span<LinkProps>`
  ${({ theme, $isLinkEnabled }) => css`
    color: ${$isLinkEnabled ? theme.colors.textLink : theme.colors.textDisabled};
    font-size: 16px;
    width: 100%;
    padding: 10px;
    cursor: ${$isLinkEnabled ? 'pointer' : 'not-allowed'};
  `}
`

export const ContainerWithButtons = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`

export const ContainerLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
